import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorShade } from '@twnel/web-components';

const Wrapper = styled.div`
  border-radius: 16px;
  display: flex;
  height: 32px;
  background: ${({ theme }) => colorShade(9, theme.actionable)};
  color: ${({ theme }) => theme.actionable};
  box-sizing: border-box;
  padding: 5px 12px 5px 5px;
  align-items: center;
`;

const Icon = styled.div`
  margin-right: 8px;
  border-radius: 50%;
  display: flex;
  height: 24px;
  align-items: center;
  width: 24px;
  justify-content: center;
  font-size: 1rem;
  background: ${({ theme }) => colorShade(2, theme.background)};
`;

const Label = styled.div`
  font-size: 1rem;
`;

const Chip = ({ label, icon }) => (
  <Wrapper>
    {icon ? (
      <Icon>
        <i className={icon} aria-hidden="true" />
      </Icon>
    ) : null}
    <Label>
      {label}
    </Label>
  </Wrapper>
);

Chip.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default Chip;
